import { getStandardButtonStyles } from "../../styles/standardButtons";
import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Stack, Switch, FormControlLabel } from "@mui/material";
import { i18n } from "../../translate/i18n";
import RemarketingTaskEditor from "../RemarketingTaskEditor";

const useStyles = makeStyles(theme => ({
  ...getStandardButtonStyles(theme),
  root: {
    display: "flex",
    flexWrap: "wrap"
  }
}));

const FlowBuilderAddRetargetingModal = ({
  open,
  onSave,
  data,
  onUpdate,
  close
}) => {
  const classes = useStyles();
  const isMounted = useRef(true);

  const [tasks, setTasks] = useState([]);
  const [isActive, setIsActive] = useState(true); // Inmortal default false? Wait, the user requirement is "No cancelar la secuencia si el contacto responde" toggle.
  const [activeModal, setActiveModal] = useState(false);
  const [nodeName, setNodeName] = useState("");

  useEffect(() => {
    if (open) {
      setTasks(data?.data?.tasks || []);
      setIsActive(data?.data?.isActive !== undefined ? data.data.isActive : true);
      setNodeName(data?.data?.name || "Retargeting");
      setActiveModal(true);
    } else if (false) {
      setTasks([]);
      setIsActive(true);
      setNodeName("Retargeting");
      setActiveModal(true);
    }
    return () => {
      isMounted.current = false;
    };
  }, [open, data]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSaveNode = () => {
    const nodeData = {
      name: nodeName,
      tasks,
      isActive
    };

    if (open) {
      onUpdate({
        ...data,
        data: { ...data.data, ...nodeData }
      });
    } else if (false) {
      onSave(nodeData);
    }
    handleClose();
  };

  return (
    <div className={classes.root}>
      <Dialog open={activeModal} onClose={handleClose} fullWidth maxWidth="md" scroll="paper">
        <DialogTitle id="form-dialog-title">
          {false ? "Añadir Nodo de Retargeting" : "Editar Nodo de Retargeting"}
        </DialogTitle>
        <Stack>
          <DialogContent dividers style={{ padding: '24px' }}>
            <FormControlLabel
              control={
                <Switch
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                  name="activeMode"
                  color="primary"
                />
              }
              label={
                <span style={{ fontWeight: '500', color: 'inherit' }}>
                  {i18n.t("flowBuilder.editor.nodes.retargeting.activate") || "Activar"}
                </span>
              }
              style={{ marginBottom: '16px' }}
            />
            
            <RemarketingTaskEditor title={i18n.t("flowBuilder.editor.nodes.retargeting.title") || "Tareas de Retargeting"} 
              tasks={tasks} 
              onChange={setTasks} 
              enableAntiBan={true}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} className={classes.secondaryButton}>
              {i18n.t("common.cancel") || "Cancelar"}
            </Button>
            <Button 
              onClick={handleSaveNode} 
              className={classes.applyButton}
            >
              {false ? (i18n.t("common.add") || "Añadir") : (i18n.t("common.save") || "Guardar")}
            </Button>
          </DialogActions>
        </Stack>
      </Dialog>
    </div>
  );
};

export default FlowBuilderAddRetargetingModal;
